var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTireFinderQuote(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.472 2.538h.01v23H4.518v-23h18.954zM6.047 4.08v19.932h15.887V4.068L6.047 4.08z",
    transform: "translate(-317 -145) translate(317 145.667)"
  }), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Overpass-Bold, Overpass",
    fontSize: 10,
    fontWeight: "bold",
    letterSpacing: 0.667,
    transform: "translate(-317 -145) translate(317 145.667)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 10.702,
    y: 14.825
  }, "$")), /*#__PURE__*/React.createElement("path", {
    d: "M20.009 21.121L20.009 22.649 7.991 22.649 7.991 21.121zM20.009 18.45L20.009 19.978 7.991 19.978 7.991 18.45z",
    transform: "translate(-317 -145) translate(317 145.667)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTireFinderQuote);
export default __webpack_public_path__ + "static/media/icon-tire-finder-quote.b62e1844cc21d93a7395dfca4bb9e3c1.svg";
export { ForwardRef as ReactComponent };